RivalIQ.apps.AdsInsights.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.TableMetricChooser = RivalIQ.apps.Dashboard.widgets.table.TableMetricChooser.extend({

        showProgressBar: true,
        saveTrackingConfig: RivalIQ.tracking.metric.V3SavedFacebookAdsMetrics,

        getMetricsCollection: function () {
            const me = this;

            const metrics = me.dashboardModel.getProp(me.metricsProp);

            // construct a metric chooser that only lets you choose fb ads metrics.
            const validChannels = RivalIQ.data.channels.clone();
            validChannels.reset([RivalIQ.data.channels.get(RivalIQ.enums.sources.FACEBOOK_ADS)]);
            return new RivalIQ.apps.Favorites.collections.Metrics(metrics, {
                parse: true,
                baseMetric: me.dashboardModel.baseMetric,
                source: RivalIQ.enums.sources.FACEBOOK_ADS,
                validChannels: validChannels
            });
        },

        getAdditionalMetrics: function () {
            const me = this;

            return _.map(me.dashboardModel.customConversionMetrics, function (customConversionMetric, metricProperty) {
                return {
                    property: metricProperty
                };
            });
        },

        onModalShown: function () {
            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.V3ViewedFacebookAdsMetricsModal);
        }
    });
});
